import React from "react";

import { SalesRequest } from "~/types/client";
import { formatDate } from "~/utils/helpers";

interface DeliveryDateInfoProps {
  selectedOrder: SalesRequest;
}

export const DeliveryDateInfo: React.FC<DeliveryDateInfoProps> = ({
  selectedOrder,
}) => {
  // Check if delivery date exists
  if (!selectedOrder.deliveryDate) {
    return null;
  }

  const deliveryDate = new Date(selectedOrder.deliveryDate);
  const today = new Date();

  // Check if delivery date is in the past
  const isPastDue = deliveryDate < today;

  // Calculate days difference
  const daysDifference = Math.ceil(
    (deliveryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
  );

  // Format delivery date
  const formattedDate = formatDate(selectedOrder.deliveryDate, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div
      className={`rounded-xl border p-5 shadow-sm ${
        isPastDue
          ? "border-red-200 bg-red-50"
          : daysDifference <= 2
            ? "border-amber-200 bg-amber-50"
            : "border-green-200 bg-green-50"
      }`}
    >
      <h3
        className={`flex items-center text-base font-semibold ${
          isPastDue
            ? "text-red-800"
            : daysDifference <= 2
              ? "text-amber-800"
              : "text-green-800"
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="mr-2 h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        Fecha de Entrega
      </h3>

      <div className="mt-2">
        <p
          className={`text-base font-medium ${
            isPastDue
              ? "text-red-700"
              : daysDifference <= 2
                ? "text-amber-700"
                : "text-green-700"
          }`}
        >
          {formattedDate}
        </p>

        {isPastDue ? (
          <p className="mt-1 text-sm text-red-600">
            <span className="font-semibold">
              Atrasado por {Math.abs(daysDifference)} días
            </span>
          </p>
        ) : (
          <p className="mt-1 text-sm text-gray-600">
            {daysDifference === 0 ? (
              <span className="font-semibold text-amber-600">Entrega hoy</span>
            ) : daysDifference === 1 ? (
              <span className="font-semibold text-amber-600">
                Entrega mañana
              </span>
            ) : (
              <span>
                Faltan{" "}
                <span className="font-semibold">{daysDifference} días</span>{" "}
                para la entrega
              </span>
            )}
          </p>
        )}
      </div>
    </div>
  );
};
